import { AxiosResponse } from "axios";
import React, { useState } from "react";
import { UseMutationResult } from "react-query";
import { useAppSelector } from "../../hooks";
import usePasswordUpdate from "../../hooks/usePasswordUpdate";
import { PasswordInfo } from "../../types";
import {passwordCheck} from "../../util/password";

const PasswordForm: React.FC = () => {
    const [password, setPassword] = useState<string>('');
    const [pwdConfirm, setPwdConfirm] = useState<string>('');
    const [pwdText, setPwdText] = useState<string>('');
    const [confirmText, setConfirmText] = useState<string>('');
    const [confirm, setConfirm] = useState<string>('N');
    const memKey = useAppSelector(state => state.auth.memKey);
    const mutation: UseMutationResult<AxiosResponse, Error, PasswordInfo> = usePasswordUpdate();
    const passwordInfo: PasswordInfo = {
        memKey: '',
        memPass: '',
    }

    const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        e.preventDefault();
        setPassword(e.target.value);
    }

    const handlePwdConfirmChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        e.preventDefault();
        setPwdConfirm(e.target.value);
    }

    const handlePasswordSave = (e: React.MouseEvent<HTMLButtonElement>, task: string) => {
        e.preventDefault();
        if ("save" === task) {
            if ("Y" === confirm) {
                passwordInfo.memKey = memKey;
                passwordInfo.memPass = password;
                mutation.mutate(passwordInfo);
            } else {
                alert("비밀번호를 맞게 입력해주세요.");
                return;
            }
        } else {
            setPassword('');
            setPwdText('');
            setConfirmText('');
            setPwdConfirm('');
            setConfirmText('');
        }
    }

    const validationCheck = (e: React.FocusEvent<HTMLInputElement>) => {
        let {name, value} = e.target;
        switch (name) {
            case "memPass" :
                let checkVal = passwordCheck(value);
                if (value.length < 8) {
                    setPwdText("비밀번호는 8자리 이상으로 입력해 주세요.");
                    setConfirm("N");
                } else if (value.length > 12) {
                    setPwdText("비밀번호는 12자리 이하로 입력해 주세요.");
                    setConfirm("N");
                } else {
                    if ("SUCC" !== checkVal) {
                        setPwdText(checkVal);
                        setConfirm("N");
                    } else {
                        setPwdText("사용가능한 패스워드 입니다.");
                    }
                }
                break;
            case "changePassRe" :
                if (value.length < 8) {
                    setConfirmText("비밀번호는 8자리 이상으로 입력해 주세요.");
                    setConfirm("N");
                } else if (value.length > 12) {
                    setConfirmText("비밀번호는 12자리 이하로 입력해 주세요.");
                    setConfirm("N");
                } else {
                    console.log(`password: ${password}, pwdConfirm: ${pwdConfirm}`);
                    if (password !== pwdConfirm) {
                        setConfirmText("비밀번호를 동일하게 입력해주세요.");
                        setConfirm("N");
                    } else {
                        setConfirm("Y");
                        setConfirmText("비밀번호가 같습니다.");
                    }
                }
                break;
        }
    }

    return (
        <>
            <fieldset className="space">
                <dl>
                    <dt><label htmlFor="changePass">비밀번호</label></dt>
                    <dd><input type="password" value={password} onChange={handlePasswordChange} onBlur={validationCheck} id="changePass" name="memPass" /> </dd>
                    <dt></dt>
                    <dd><span id="pw_txt1" className="red ml5">{pwdText}</span></dd>
                    <dt><label htmlFor="changePassRe">비밀번호 확인</label></dt>
                    <dd><input type="password" value={pwdConfirm} onChange={handlePwdConfirmChange} onBlur={validationCheck} id="changePassRe" name="changePassRe" /> </dd>
                    <dt></dt>
                    <dd><span id="pw_txt2" className="red ml5">{confirmText}</span></dd>
                </dl>
            </fieldset>
            <div className="btn">
                <button type="button" className="m gray" onClick={(e) => handlePasswordSave(e, "save")}>완료</button>
                <button type="button" className="m gray" onClick={(e) => handlePasswordSave(e, "cancel")}>취소</button>
            </div>
        </>
    )
}

export default PasswordForm;